module.exports = __webpack_public_path__ + "img/bh.cdf1a88b.svg";